import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.028 2.15A2.654 2.654 0 0 1 8 1.25c.756 0 1.464.335 1.972.9.505.561.778 1.308.778 2.072v3.556c0 .764-.273 1.51-.778 2.073-.508.564-1.216.899-1.972.899-.373 0-.74-.082-1.079-.238a2.75 2.75 0 0 1-.893-.661 3.003 3.003 0 0 1-.579-.96 3.188 3.188 0 0 1-.199-1.113V4.222c0-.764.273-1.51.778-2.073Z"
      fill="currentColor"
    />
    <path
      d="M12.344 9.389c-.344 1.11-.765 1.876-1.516 2.553C10.078 12.62 9.061 13 8 13c-1.06 0-2.078-.38-2.828-1.058C4.422 11.265 4 10.5 3.656 9.39M8 13v2"
      stroke="currentColor"
      strokeWidth={1}
    />
  </svg>
);

const StyledSvgMicrophone = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgMicrophone;
